import "./css/index.scss";
import "./css/barcode.scss";
import "./css/logo.scss";

import "jquery-ui/ui/core";
import "jquery-ui/ui/widgets/slider";
import "jquery-ui/ui/widgets/sortable";
import "jquery-ui/ui/effects/effect-highlight";

import "./toggles.js";

import { onViewLoad } from "~/jose_modern/on_view_load";
import { initializeRecipeBarcode } from "./barcode/index.js";
import { initializeRecipeLogo } from "./logo/index.js";

onViewLoad("recipes#show", () => {
  initializeRecipeBarcode();
  initializeRecipeLogo();
});
